import { AlertTriangle, X } from "lucide-react";
import { useImageDelete } from "@/hooks/useImageDelete";
import { useLanguage } from "@/contexts/LanguageContext";

interface FailedMediaPlaceholderProps {
  items: Array<{ id: string }>;
  label: string;
}

export function FailedMediaPlaceholder({
  items,
  label,
}: FailedMediaPlaceholderProps) {
  const { deleteImage, isDeleting } = useImageDelete();
  const { t } = useLanguage();

  if (items.length === 0) return null;

  return (
    <>
      {items.map((item) => (
        <div
          key={`failed-${item.id}`}
          className="relative border-[2px] border-border bg-destructive/5 aspect-[9/16] flex flex-col items-center justify-center"
        >
          {/* Remove button */}
          <button
            onClick={() => deleteImage(item.id)}
            disabled={isDeleting}
            aria-label={t.common.delete}
            className="absolute top-2 end-2 w-6 h-6 rounded-full bg-secondary flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>

          <AlertTriangle className="w-8 h-8 md:w-10 md:h-10 text-muted-foreground mb-2 md:mb-3" />
          <span className="text-muted-foreground text-xs font-medium px-2 text-center">
            {label}
          </span>
        </div>
      ))}
    </>
  );
}
